function getVariable(name) {
  if (!process.env[name]) {
    const error = new TypeError(`Lost environment variables ${name}`)
    const h2 = document.createElement('h2')
    const pre = document.createElement('pre')

    h2.innerText = 'Unexpected Application Error!'
    pre.innerHTML = error.toString()

    document.body.appendChild(h2)
    document.body.appendChild(pre)

    throw error
  }

  return process.env[name]
}

export const GRECAPTCHA_SITE_KEY = getVariable('REACT_APP_GRECAPTCHA_SITE_KEY')

export const RUNTIME_DOMAIN = getVariable('REACT_APP_RUNTIME_DOMAIN')

export const LOG_ROCKET_APP_ID = getVariable('REACT_APP_LOG_ROCKET_APP_ID')

export const USE_MOCK = process.env.REACT_APP_USE_MOCK === 'true'
